export default function getFirstOrderId({ state, props }) {
  const orders = state.get('orderHistory.history')
  return { id: Object.keys(orders)[0] }
}



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/actions/getFirstOrderId.js